<template>
  <header :class="blackText?'black--text':'white--text'">
    <div id="progress-bar" class="progress-bar">
      <div class="progress-indicator" :style="'width: '+progress+'%'"></div>
    </div>
    <v-layout row align-begin wrap>
      <v-flex xs12 justify-begin>
        <v-layout row>
          <v-flex>
            <router-link to="/">
              <img src="../assets/imagenes_compartidas/logo_ecopetrol.png" class="hidden-xs-only">
            </router-link>
          </v-flex>
          <v-flex xs12>
            <p class="mb-0">Curso: <span class="nombre-curso">El ABC de las Reservas y los Recursos de Hidrocarburos</span></p>
            <p class="nombre-modulo hidden-sm-and-down">{{temaName}} <span v-if="$route.path.split('/')[2] != '0'">- {{subtemaName}}</span></p>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12 md4 justify-end>
        <div class="right-content text-xs-right text-sm-right">
          <p>{{temaName}}
          </p>
        </div>
      </v-flex> -->
    </v-layout>
  </header>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  methods:{
    },
  computed: {
    progress() {
      return (this.currentPage / this.screenTrack[1]) * 100
    },
    blackText() {
      return this.temaName.includes('Módulo 1') || this.temaName.includes('Módulo 2')
    },
    subtemaName(){
      return this.$store.state.subTema
    },
    screenTrack() {
      return this.$store.state.screens;
    },
    temaName() {
      return this.$store.state.tema;
    },
    showTrack() {
      var routeArr = this.$route.path.split("/");
      if (routeArr.length <= 2) {
        return false
      } else {
        return true
      }
    },
    currentPage() {
      return Math.floor(this.$route.params.unipage);
    }
  }

}
</script>
<style lang="scss" scoped>
@import '../sass/globals';

.progress-bar, .progress-indicator{
  position: absolute;
  height: 15px;
  background-color: #fafafa;
  border-radius: 10px;
  display: block;
}
.progress-bar{
  position: relative;
  width: calc(100% - 40px);
  margin: auto;
  border: 1px solid gray;
  margin-bottom: 5px;
}
.progress-indicator{
  transition: width 500ms;
  background-color: #8ebc00;
  bottom: 0;
  height: 14px;
  border: 1px solid transparent;
}

img{
  max-height: 70px;
  padding: 5px;
  padding-left: 30px;
  background: white;
  // max-width: 30%;
}

p{
  line-height: calc(1em + 10px);
  padding-left: 30px;
  font-size: 1.2em;
  @media (max-width: 700px) {
    padding-left: 10px;
    font-size: 1.1em;
  }

}

.nombre-curso, .nombre-modulo {
  font-family: helveticaNeueCn;
  font-weight: bold;
}

header {
  padding: 5px 0;
  margin-bottom: 10px;
  position: relative;

  @media (max-width: 600px) {
      max-height: 5rem;
      margin-left: 0;
      margin-bottom: 0;
  }
}

.right-content {
  text-align: right;
  margin-right: 50px;
}

</style>

